<template>
  <div class="c-result-full">
    <div>
      <c-modal-message
        v-show="showModal"
        :show.sync="showModal" full-title="Вы уверены что хотите принудительно согласовать результат?"
        @agree="agreeTest"
      />
      <c-modal-message
        v-show="showModalDelete"
        :show.sync="showModalDelete" full-title="Вы уверены что хотите удалить результат?"
        @agree="deleteTest"
      />
      <n-card class="result-card">
        <n-loader :loading="$var('load')" />
        <div class="card-top">
          <n-button flat @click="closeModal">X</n-button>
        </div>
        <div>
          <h3>Инфо аттестации</h3>
          <div class="right-align">
            <div v-if="deleteResult" class="delete-btn" @click="showModalDelete = true">
              Удалить тестирование
            </div>
          </div>
          <n-items class="info">
            <div>Категория: {{ result.category ? result.category.title : '' }}</div>
            <div>Результат: {{ Math.round(result.points) + '%' }}</div>
            <div>Дата начала тестирования: {{ $app.date.format(result.createdAt) }}</div>
            <div>Аттестатор: {{ result.author ? result.author.fullName : '' }}</div>
            <div>Табельный номер: {{ result.author ? result.author.personnelNumber : '' }}</div>
            <div>Аттестируемый: {{ result.user ? result.user.fullName : '' }}</div>
            <div>Табельный номер: {{ result.user ? result.user.personnelNumber : '' }}</div>
            <div>Филиал: {{ result.branch?.title }}</div>
            <div>Кол-во правильных ответов: {{ result.correctCount }}</div>
            <div>Кол-во вопросов: {{ result.questionsCount }}</div>
            <div>Награда: {{ result.reward }}</div>
            <div>Количество отказов: {{ result.declineCount }}</div>
<!--            <div>Тип тестирования: {{ types[result.resultType] }}</div>-->
            <div>Статус тестирования: {{ statuses[result.status] }}</div>
          </n-items>
          <div v-if="result.declineCount > 2 && result.stats === 'unaccepted'" class="made-accepted" @click="showModal = true">
            Принудительное согласование
          </div>
        </div>
        <h3>Разделы</h3>
        <div class="quizzes-lint">
          <div v-for="item in quizzes" :key="item.id" class="quiz-block" @click="selectQuiz(item)">
            <div class="image-place" :class="{'active': item.id === quiz.id}">
              <div v-if="item.countIgnored >0" style="left: 10px" class="circle">
                {{ item.countIgnored }}
              </div>
              <div v-if="item.haveIncorrect" class="circle">
                !
              </div>
<!--              <div class="image-wrapper">-->
<!--                <img :src="item.image" alt="">-->
<!--              </div>-->
            </div>
            <p>{{ item.title }}</p>
          </div>
        </div>

        <div class="category-headers">
          <h3>{{ category.parent ? category.parent[0].title : '' }}</h3>
          <h4>{{ category ? category.title : '' }}</h4>
        </div>
        <!--        <div class="save">-->
        <!--          <div class="save-btn" @click="saveAnswers()">-->
        <!--            Сохранить-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <ul :key="$var('reload')" class="questions-list">-->
        <!--          <li v-for="item in questions" :key="item.id" class="question-row">-->
        <!--            <label v-if="!item.parentId" class="question-label">-->
        <!--              <input v-if="!item.isMemo" type="checkbox" :checked="isChecked(item)" @click="answerClick(item.id, false, item)">-->
        <!--              <span :class="{'memo': item.isMemo}">{{ item.title }}</span>-->
        <!--            </label>-->
        <!--            <div v-if="item.subquestions.length > 0" class="sub-questions">-->
        <!--              <label v-for="(subItem, index) in item.subquestions" :key="index" class="sub-question-label" :class="{'memo': subItem.isMemo}">-->
        <!--                <input v-if="!subItem.isMemo" type="checkbox" :checked="isChecked(subItem)" @click="answerClick(subItem.id, false, subItem)">-->
        <!--                <span :class="{'memo': subItem.isMemo}">{{ subItem.title }}</span>-->
        <!--              </label>-->
        <!--            </div>-->
        <!--          </li>-->
        <!--        </ul>-->
        <ul :key="$var('reload')" class="questions-list">
          <li v-for="item in questions" :key="item.id" class="question-row">
            <label v-if="!item.parentId" class="question-label">
              <img v-if="checkState(item.id) === 'ignored'" :src="iconIgnored" alt="">
              <img v-else :src="checkState(item.id) === 'correct' ? iconCorrect : iconIncorrect" alt="">
              <span :class="{'memo': item.isMemo}">{{ item.title }}</span>
            </label>
            <div v-if="item.subquestions.length > 0" class="sub-questions">
              <label v-for="(subItem, index) in item.subquestions" :key="index" class="sub-question-label" :class="{'memo': subItem.isMemo}">
                <img v-if="checkState(subItem.id) === 'ignored'" :src="iconIgnored" alt="">
                <img v-else :src="checkState(subItem.id) === 'correct' ? iconCorrect : iconIncorrect" alt="">
                <span :class="{'memo': subItem.isMemo}">{{ subItem.title }}</span>
              </label>
            </div>
          </li>
        </ul>
      </n-card>
    </div>
  </div>
</template>

<script>
import iconCorrect from 'assets/icon-correct.svg'
import iconIncorrect from 'assets/icon-incorrect.svg'
import iconIgnored from 'assets/icon-deleted.svg'

export default {
  name: 'CResultFull',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      iconIncorrect,
      iconIgnored,
      iconCorrect,
      showModalDelete: false,
      types: {
        education: 'Обучение',
        kln: 'КЛН',
      },
      statuses: {
        finished: 'Согласован',
        interrupted: 'Прерван',
        unaccepted: 'Не подтвержден',
        expired: 'Автосогласованный',
        declined: 'Не согласован',
      },
      columns: [
        { name: 'question.title', title: 'Вопрос', },
        { name: 'value', title: 'Ответ', },
        { name: 'ignored', title: 'Проигнорирован', },
      ],
      category: {},
      result: {},
      data: [],
      quiz: {},
      quizzes: [],
      questions: [],
      showModal: false,

      answers: {},
      needComment: false,
      comment: '',
      deletedQuestionId: null,
      headers: { title: 'Квиз', type: 'Теория', },
      hide: true,
      state: '',
      quizzesCount: 0,
      finishedQuizzes: 0,
      isAbleToIgnore: false,
      ignoredQuestions: {},
      modalType: 'interrupt',
      clickCount: 0,
      user: {},
      isLogout: false,
      deleteResult: false,
    }
  },
  watch: {
    quiz() {
      this.loadQuestions()
    },
  },
  created() {
    this.loadResult()
    this.loadCategory()
    this.loadAuth()
  },
  methods: {
    deleteTest() {
      this.$var('load', true)
      $api.results.delete(this.id).then(() => {
        this.closeModal()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    closeModal() {
      this.$emit('update:show', false)
    },
    checkState(questionId) {
      questionId = questionId+''
      if (this.answers[questionId]) {
        return this.answers[questionId].value && !this.answers[questionId].ignored ? 'correct' : this.answers[questionId].ignored ? 'ignored' : 'incorrect'
      } else {
        return 'incorrect'
      }
    },
    agreeTest() {
      this.$var('load', true)
      $api.results.makeFinish(this.id).then(() => {
        this.loadResult()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadResult() {
      this.$var('load', true)
      $api.results.get(this.id).all().with('user').with('branch').with('category')
        .with('author').with('answers').then((response) => {
          this.result = response.data.content
          const existedAnswers = response.data.content.answers
          if (existedAnswers) {
            $n.map(existedAnswers, (elem) => {
              this.answers = {
                ...this.answers,
                [elem.questionId+'']: {
                  value: elem?.value,
                  ignored: elem.ignored,
                },
              }
            })
          }
          this.loadQuizzes()
        }).catch(() => {
          this.$var('load', false)
        })
    },
    loadQuizzes() {
      const query = 'resultId='+this.result.id
      $api.quizzes.getByCategory(this.result.categoryId).all().with('haveIncorrect').with('countIgnored').query(query).then((response) => {
        this.quizzes = response.data.content
        this.quizzesCount = this.quizzes.length
      }).catch(() => {
        this.$var('load', false)
      })
    },
    loadQuestions() {
      this.$var('load', true)
      $api.questions.get(this.quiz.id).all().with('subquestions').then((response) => {
        this.questions = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadCategory() {
      $api.categories.get(this.result.categoryId).all().with('parent').then((response) => {
        this.category = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadAuth() {
      $api.auth.info().with('accesses').then((response) => {
        this.authuser = response.data.content
        const requiredRoles = [ 'superAdmin', 'director', 'deputyDirector', ]
        let hasRequiredRole = false
        for (let i = 0; i < this.authuser.user.accesses.length; i++) {
          if (requiredRoles.includes(this.authuser.user.accesses[i].title)) {
            hasRequiredRole = true
            break
          }
        }
        if (this.result.status === 'interrupted' && hasRequiredRole) {
          this.deleteResult = true
          console.log(this.result.status)
        }
      }).finally(() => {
        this.$var('load', false)
      })
    },
    selectQuiz(quiz) {
      this.quiz = quiz
    },
    next(quiz) {
      const query = 'resultId='+this.resultId
      $api.quizzes.get(this.category.id).all().with('haveIncorrect').query(query).then((response) => {
        this.quizzes = response.data.content
        if (quiz) {
          this.quiz = this.quizzes[this.quizzes.findIndex((elem) => {
            return elem.id === quiz.id
          })]
        } else {
          const nextIndex = this.quizzes.findIndex((elem) => {
            return elem.id === this.quiz.id
          })
          if (nextIndex+1 > this.quizzes.length-1) {
            this.quiz = this.quizzes[0]
          } else {
            this.quiz = this.quizzes[nextIndex+1]
          }
        }
      })
    },
    saveAnswers() {
      this.$var('load', true)
      $api.answers.save(this.id, this.quiz.id, { answers: this.answers, }).then((response) => {
        $api.results.patch(this.id, { status: 'unaccepted', }).then(() => {
          this.loadResult()
        }).finally(() => {
          this.$var('load', false)
        })
      }).catch(() => {
        this.$var('load', false)
      })
    },
    isChecked(answer) {
      const id = answer.id.toString()
      let allChildsChecked = true
      const question = $n.find(this.questions, (e) => {
        if (e.id === answer.id) {
          return e
        }
      })
      const child = question?.subquestions
      $n.each(child, (e) => {
        if (!this.answers?.[e.id]?.value && !this.answers?.[e.id]?.ignored && !e.isMemo) {
          allChildsChecked = false
        }
      })

      // if (child.length > 0 && this.answers[question.id]?.value !== allChildsChecked) {
      //   this.answers = {
      //     ...this.answers,
      //     [question.id]: {
      //       ...this.answers[question.id],
      //       value: true,
      //     },
      //   }
      // }

      return (this.answers?.[id] ? this.answers[id]?.value : false) || (allChildsChecked && child.length > 0)
    },
    turnOn(question, answer, isIgnored = false) {
      $n.map(question.subquestions, (e) => {
        this.answers[e.id]= {
          value: isIgnored?false: !answer?.value,
          ignored: false,
        }
      })
    },
    answerClick(questionId, isIgnored = false, question = null) {
      if (!question) {
        question = $n.find(this.questions, (e) => {
          if (e.id+'' === questionId) {
            return e
          }
        })
      }
      if (question?.isParent) {
        const answer = this.answers[questionId]
        this.answers = {
          ...this.answers,
          [questionId]: {
            value: isIgnored?false: !(this.answers[questionId]?.value),
            ignored: isIgnored? !(this.answers[questionId]?.ignored) : false, },
        }
        this.turnOn(question, answer, isIgnored)
      } else {
        this.answers = {
          ...this.answers,
          [questionId]: {
            value: isIgnored?false: !(this.answers[questionId]?.value),
            ignored: isIgnored? !(this.answers[questionId]?.ignored) : false, },
        }
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.c-result-full {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .save {
    display: flex;
    align-items: center;
    justify-content: right;
    .save-btn {
      cursor: pointer;
      padding: 10px;
      border-radius: 12px;
      color: #ffffff;
      background-color: green;
    }
  }

  .made-accepted {
    height: 60px;
    max-width: 260px;
    background-color: red;
    color: #ffffff;
    padding: 10px;
    margin-bottom: 30px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .right-align {
    display: flex;
    align-items: center;
    justify-content: right;
  }

  .delete-btn {
    background-color: red;
    color: #ffffff;
    padding: 10px;
    margin-bottom: 30px;
    font-size: 10px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .questions-list{
    list-style: none;
    height: calc(100vh/1.4);
    overflow: auto;
    padding: 0;
    .question-row{
      margin: 28px 0 0 0;
      flex-shrink: 0;
      .sub-questions {
        padding: 10px 35px;
        .image-place {
          margin-right: 15px;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .sub-question-label{
        margin-bottom: 5px;
        img{
          width: 44px;
          height: 44px;
          padding-right: 20px;
        }
        &.ignored {
          display: none;
        }
        &:last-child {
          margin-bottom: 0;
        }
        display: flex;
        align-items: center;


      }
      .question-label {
        display: flex;
        align-items: center;
        img{
          width: 44px;
          height: 44px;
          padding-right: 20px;
        }
        .image-place {
          margin-right: 15px;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      &.ignored {
        display: none;
      }
      .ignore-button {
        position: relative;
        background-color: red;
        color: red;
        width: 20px;
        height: 20px;
        margin: 0 14px 0 0;

        :before {
          content: '-';
          position: absolute;
          font-size: 2.0em;
          color: #ffffff;
          z-index: 9;
          width: 10px;
          height: 2px;
          left: 3px;
          top: -12px;
        }
        &.ignored {
          background-color: lightgreen;
          color: lightgreen;

          :before {
            content: '+';
            position: absolute;
            font-size: 1.2em;
            color: #ffffff;
            z-index: 9;
            width: 10px;
            height: 2px;
            left: 3px;
            top: -2px;
          }
        }
      }

      input {
        width: 20px;
        height: 20px;
        margin: 0 15px 0 0;
      }
      input:checked+label::before {
        background-color: var(--primary);
      }
      p {
        margin: 0;
        padding: 0;
        font-size: 17px;
        color: #000000;
        flex: 2;
      }
    }
  }

  .info {
    padding: 5px;
    background-color: #f6f6f6;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    column-count: 2;
    max-height: 300px;
    margin-bottom: 20px;
    flex-wrap: wrap
  }

  .quizzes-lint {
    display: flex;
    overflow: auto;

    .quiz-block {
      margin-right: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        font-size: 0.9em;
        text-align: center;
      }

      .image-place {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        border-radius: 12px;
        background-color: #d6d5d5;
        position: relative;
        .circle {
          position: absolute;
          left: 0;
          top: 0;
          background-color: red;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
        }

        .image-wrapper {
          width: 44px;
          height: 44px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        &.active {
          background-color: var(--primary);
        }
      }
    }
  }

  .answers-list {
    .answer-row {
      margin-top: 30px;

      .answer {
        position: relative;
        display: flex;
        align-items: center;

        .image-place {
          margin-right: 15px;
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .answer-title {
          flex: 2;
        }
      }

      .sub-answer {
        position: relative;
        display: flex;
        align-items: center;
        padding: 10px 35px;

        .image-place {
          margin-right: 15px;
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .answer-title {
          flex: 2;
        }
      }
    }
  }

  .result-card {
    width: 1200px;
    height: 800px;
    position: relative;
  }

  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }

  .card-top {
    display: flex;
    align-items: center;
    justify-content: right;
  }

  .memo {
    font-style: italic;
  }
}
</style>
